import BaggageImg from "./Baggage.svg";
export const Baggage: React.FunctionComponent = () => {
  return (
    <>
      <h1 className="amd-heading1">Baggage</h1>
      <section className="amd-section-shadow my-4">
        <img src={BaggageImg} alt="Baggage" width={"100%"} />
      </section>
    </>
  );
};
